'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002e$002dL18n$0024 from "./app.localization.-L18n$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_app$002ewebclient$005fprelude$002eprelude$002e$002dApp$002dIcons$0024 from "./app.webclient_prelude.prelude.-App-Icons$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_components_instances$package$$anon$10(x$1$14) {
  this.Xw = null;
  this.Xw = x$1$14;
}
export { $c_Lapp_components_instances$package$$anon$10 as $c_Lapp_components_instances$package$$anon$10 };
$p = $c_Lapp_components_instances$package$$anon$10.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_components_instances$package$$anon$10;
/** @constructor */
function $h_Lapp_components_instances$package$$anon$10() {
}
export { $h_Lapp_components_instances$package$$anon$10 as $h_Lapp_components_instances$package$$anon$10 };
$h_Lapp_components_instances$package$$anon$10.prototype = $p;
$p.bJ0 = (function() {
  var this$1 = $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().ay();
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$3(this.Xw, this$1).nY(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$2(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1$1) => {
    var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if (((x === null) ? (x$1$1 === null) : (x === x$1$1))) {
      return "Form contains invalid fields.";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$1);
  })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().ay()));
});
$p.boq = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_ButtonContents$().bpT($j_app$002elocalization$002e$002dL18n$0024.$m_Lapp_localization_L18n$().aVL.bD(this.Xw), $j_app$002elocalization$002e$002dL18n$0024.$m_Lapp_localization_L18n$().aVM.bD(this.Xw), $j_app$002elocalization$002e$002dL18n$0024.$m_Lapp_localization_L18n$().ahP.bD(this.Xw), $j_app$002ewebclient$005fprelude$002eprelude$002e$002dApp$002dIcons$0024.$m_Lapp_webclient\uff3fprelude_prelude_AppIcons$().bBw());
});
var $d_Lapp_components_instances$package$$anon$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_components_instances$package$$anon$10, "app.components.instances$package$$anon$10", ({
  yY: 1,
  Xf: 1
}));
export { $d_Lapp_components_instances$package$$anon$10 as $d_Lapp_components_instances$package$$anon$10 };
//# sourceMappingURL=app.components.instances$package$$anon$10.js.map
